export default "__VITE_PUBLIC_ASSET__10ad0b78__"